export default {
  'name': 'Name',
  'email': 'Email',
  'website': 'Website',
  'companyName': 'Company Name',
  'mobile': 'Mobile',
  'createTime': 'Create Time',
  'operation': 'Operation',
  'del': 'Delete',
  'details': 'Detail',

  'num': 'Num',
  'title': 'Title',
  'description': 'Description',
  'startTime': 'Start Time',
  'endTime': 'End Time',
  'deadline': 'Deadline',
  'place': 'Place',
  'sort': 'Sort',
  'status': 'Status',
  'reason': 'Reason',
  'createTimeActor': 'Create Time',
  'boothNum': 'Booth Num',

  'businessNature':'BusinessNature',
  'productImg': 'ProductImg',
  'certificates': 'Certificates',
  'purchaseQuantity': 'PurchaseQuantity',
  'unit': 'Unit',
  'suppliersBusinessNature': 'Suppliers Business Nature',
  'suppliersScale': 'Suppliers Scale',
  'suppliersRegion': 'Suppliers Region',
  'other': 'Other',
  'expectedDate': 'ExpectedDate',
  'answers': 'Answers',
  'Tips': 'This operation will permanently delete this information. Do you want to continue?',
  'Deletion cancelled': 'Deletion cancelled',
  'Registration Info': 'Registration Info',

  'procurementStartTime': 'Please select a start time',
  'procurementEndTime': 'Please select an end time',
  'pleaseEnter': 'Please enter'
}
